export const getBaseAndAlphaColor = (hex: string) => {
  hex = hex.replace(/^#/, '')

  let base: string
  let zero: string

  if (hex.length === 6) {
    base = `#${hex}`
    zero = `#${hex}00`
  } else if (hex.length === 8) {
    base = `#${hex.slice(0, 6)}`
    zero = `#${hex.slice(0, 6)}00`
  } else {
    throw new Error('Neplatný hex kód. Očekáván formát #RRGGBB nebo #RRGGBBAA.')
  }

  return {
    base,
    zero,
  }
}
